module.exports = __webpack_public_path__ + "static/media/static-2.9abe8295.png";